import { useLocation, useNavigate } from "react-router-dom";
import { useUploadModal } from "../../../context/UploadModalContext";

const UploadNav = () => {
  const { openGuidelineMobileModal } = useUploadModal();
  const getTitleByPath = (pathname: string) => {
    if (pathname.includes("/upload")) return "Upload Required Documents";
    if (pathname.includes("/payment")) return "Checkout";
    if (pathname.includes("/thankyou")) return "booking confirmation";
    return "Upload Required Documents"; // Default title
  };

  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  const title = getTitleByPath(location.pathname);

  return (
    <>
      <div className="container-fluid px-4 border-bottom fixed-top bg-white d-none d-md-block">
        <div className="d-flex  align-items-center p-2 py-3">
          <div className="flex-grow-1 text-center ">
            <p className="font-21 font-sm-12 text-uppercase ff-bold mb-0 text-black">
              {title}
            </p>
          </div>

          <div onClick={() => navigate("/cart")} className="cursor-pointer">
            <svg
              width="16"
              height="16"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22 1L1 22"
                stroke="black"
                strokeWidth="1.96875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1 1L22 22"
                stroke="black"
                strokeWidth="1.96875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="container-fluid px-4 border-bottom fixed-top bg-white d-block d-md-none">
        <div className="d-flex align-items-center gap-3 py-3 justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <button
              onClick={goBack}
              className="back-icon bg-white border-0 d-flex"
            >
              <svg
                width="8"
                height="15"
                viewBox="0 0 8 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 1.3219L1 7.3219L7 13.3219"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <p className="font-16 ff-semibold mb-0 text-black "> {title}</p>
          </div>
          <div>
            <p
              className="mb-0 px-3 py-2 bg-3 rounded-pill text-main ff-semibold"
              onClick={openGuidelineMobileModal}
            >
              {title === "Checkout" ? "Payment Summery" : "Guideline"}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadNav;
